export const MARKETING_SIGN_UP_TEXT =
  "Keep me informed about product updates, engineering tips, and offers.";

export const NEWSLETTER_SIGNUP_PAGE_SOURCE = "Newsletter signup page";
export const CREATE_ACCOUNT_SOURCE = "Create Account";
